export default __webpack_public_path__ + "static/media/logo.834a89c9.webp";